import KeyboardListener from './keyboard/keyboard.listener';
import without from 'lodash/without';
import every from 'lodash/every';
import defaults from 'lodash/defaults';

let _keyupListeners = [];

const DEFAULT_OPTIONS = {
   unshift: false,
   ignoreInput: true,
   shareEvent: false,
   stop: false,
   prevent: false,
   manageKeys: []
};

class KeyboardHelper {
   constructor() {
      window.addEventListener('keydown', _listener);
   }

   keydown(callback, key, options) {
      options = defaults(options, DEFAULT_OPTIONS);
      const listener = new KeyboardListener(callback, key, options);
      if (options.unshift) {
         _keyupListeners.unshift(listener);
      } else {
         _keyupListeners.push(listener);
      }
      return function _off() {
         _keyupListeners = without(_keyupListeners, listener);
      };
   }
}

function _listener(e) {
   every([..._keyupListeners], l => l.handle(e));
}

export default new KeyboardHelper();
